import React from "react";

type Props = {
    src: string;
    slug?: string;
    width?: number;
    alt?: string;
};

const ImageLink = ({src, slug, width = 100, alt = ""}: Props) => {
    return (
        <div data-column={slug} style={{width: `${width}px`}}>
            <a href={src} target="_blank" rel="noopener noreferrer">
                <img src={src} alt={alt} style={{width: "100%", display: "block"}} />
            </a>
        </div>
    );
};

export default ImageLink;
